<div class="pkt-form-field" [class.pkt-error-state]="!!errorMessage" [matTooltip]="tooltip"
  [matTooltipDisabled]="!tooltip" matTooltipPosition="right">
  <mat-checkbox [checked]="value" [indeterminate]="indeterminate" [disabled]="disabled"
    (change)="onCheckChange($event.checked)">
    {{ label }}<span *ngIf="required" class="pkt-required">*</span>
  </mat-checkbox>

  <div *ngIf="hint && !errorMessage" class="pkt-hint">{{ hint }}</div>
  <div *ngIf="errorMessage" class="pkt-error-msg">
    <span class="material-symbols-outlined">error</span>{{ errorMessage }}
  </div>
</div>